import { FC, ReactElement } from 'react'
import classnames from 'classnames'
import { formatDistanceToNow } from 'date-fns'

import { Avatar, Badge } from '@/components'
import { NotificationItem } from '@/entities/Notification/Notification'
import { getDateFnsLocale } from '@/helpers/date'

import './NotificationListItem.scss'

interface NotificationListItemProps {
    notification: NotificationItem
    onClick?: (notification: NotificationItem) => void
}

export const NotificationListItem: FC<NotificationListItemProps> = ({ notification, onClick }): ReactElement => (
    <li className={classnames('notification-list-item', {
        'notification-list-item--unread': ! notification.read,
    })}
    >
        <button
            type="button"
            className="notification-list-item__button"
            onClick={() => onClick?.(notification)}
        >
            <Avatar
                className="notification-list-item__avatar"
                icon="bell"
                image={notification.actor?.image}
                initials={notification.actor?.name?.charAt(0)}
                name={notification.actor?.name}
            />

            <div className="notification-list-item__content">
                <span className="notification-list-item__title">{notification.title}</span>
                {notification.body && (
                    <span className="notification-list-item__body">{notification.body}</span>
                )}
                <time className="notification-list-item__time" dateTime={notification.createdAt.toISOString()}>
                    {formatDistanceToNow(notification.createdAt, { addSuffix: true, locale: getDateFnsLocale() })}
                </time>
            </div>

            {! notification.read && (
                <Badge value={notification.unreadCount} className="notification-list-item__unread" />
            )}
        </button>
    </li>
)
